import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const FloatingIconContainer = styled.div<React.CSSProperties>`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: inherit;
  justify-content: center;
  width: ${86 * Screen.widthRatio}px;
`;

export default FloatingIconContainer;
